module.exports = __webpack_public_path__ + "img/text3@3x.5d73de85.png";